import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/css';
import { Box } from '@mui/material';

const SliderAdvertisement: React.FC<any> = (props) => {

  return (
    <Box>
      <Box sx={{ display: props.widthDisplay, textAlign: 'center', mb: -2 }}>
        <Splide
          options={{
            type: 'loop',
            perPage: 2,
            perMove: 1,
            autoplay: true,
            interval: 20000,
          }}
        >
          <SplideSlide>
            <img src="/manual/e2.png" width='100%' height='100%' style={{border: '1px solid #dcdcdc'}}/>
          </SplideSlide>
          <SplideSlide>
            <img src="/manual/easy.png" width='100%' height='100%' style={{border: '1px solid #dcdcdc'}}/>
          </SplideSlide>
          <SplideSlide>
            <img src="/manual/all.png" width='100%' height='100%' style={{border: '1px solid #dcdcdc'}}/>
          </SplideSlide>
          <SplideSlide>
            <img src="/manual/sakuwari.png" width='100%' height='100%' style={{border: '1px solid #dcdcdc'}}/>
          </SplideSlide>
          <SplideSlide>
            <img src="/manual/sensor.png" width='100%' height='100%' style={{border: '1px solid #dcdcdc'}}/>
          </SplideSlide>
        </Splide>
      </Box>

      <Box sx={{ display: props.smallDisplay, textAlign: 'center', mb: -2 }}>
        <Splide
          options={{
            type: 'loop',
            perPage: 1,
            perMove: 1,
            autoplay: true,
            interval: 20000,
          }}
        >
          <SplideSlide>
            <img src="/manual/e2.png" width='100%' height='100%' style={{border: '1px solid #dcdcdc'}}/>
          </SplideSlide>
          <SplideSlide>
            <img src="/manual/easy.png" width='100%' height='100%' style={{border: '1px solid #dcdcdc'}}/>
          </SplideSlide>
          <SplideSlide>
            <img src="/manual/all.png" width='100%' height='100%' style={{border: '1px solid #dcdcdc'}}/>
          </SplideSlide>
          <SplideSlide>
            <img src="/manual/sakuwari.png" width='100%' height='100%' style={{border: '1px solid #dcdcdc'}}/>
          </SplideSlide>
          <SplideSlide>
            <img src="/manual/sensor.png" width='100%' height='100%' style={{border: '1px solid #dcdcdc'}}/>
          </SplideSlide>
        </Splide>
      </Box>
    </Box>
  );
};

export default SliderAdvertisement;